import { TranslationType } from '../types';

export const masterPoolTypeMapping = (t: TranslationType) => {
  const mapping = {
    '01': t('Owner-Occupied-Amortizing-1st-Position'),
    '02': t('Rental-1-4-Units-Amortizing-1st-Position'),
    '03': t('HELOC-1st-Position'),
    '04': t('HELOC-2nd-Position'),
    '05': t('CMHC-SES-Product')
  };
  return mapping;
};
